import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {InvoiceHistoryResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/InvoiceHistoryResponse';
import {InvoiceResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/InvoiceResponse';
import {InvoiceRowResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/InvoiceRowResponse';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';

export class InvoicesController
{
    public syncInvoiceHistory():void
    {
        controllers.net.billing
            .getInvoiceHistory().then(action((response:InvoiceHistoryResponse) =>
        {
            if( ApiError.isError(response) )
                return;

            rootState.ui.invoices.invoiceHistory = response;
        }));
    }

    public getInvoiceHistory():InvoiceHistoryResponse | null
    {
        const {invoices} = rootState.ui;
        const {invoiceHistory} = invoices;

        if( !invoiceHistory )
            return null;

        return invoiceHistory;
    }

    public showDetails(invoice):void
    {
        rootState.ui.invoices.invoiceDetails = new InvoiceResponse(invoice);

        let {invoiceDetails} = rootState.ui.invoices;

        this.syncInvoiceDetails(invoiceDetails.number);

        controllers.ui.dialogs.showDialog(Dialogs.InvoiceDetails, false);
    }

    public syncInvoiceDetails(number:number):void
    {
        controllers.net.billing.getInvoice(number)
        // .then(action((response:InvoiceResponse)=> // TODO uncomment
            .then(action((response:any) => // TODO remove
            {
                if( ApiError.isError(response) )
                    return;

                // TODO remove
                if( !response.rows )
                    response.rows = randomRows();

                if( response.rows )
                {
                    let invoice = rootState.ui.invoices.invoiceDetails;
                    invoice.rows = response.rows;
                }
            }));
    }
}

// TODO remove after implementation of api -> getInvoice

enum UnitPeriod
{
    one_time = 'one_time',
    hour = 'hour',
    day = 'day',
    week = 'week',
    month = 'month',
    quarter = 'quarter',
    semi_annual = 'semi_annual',
    annual = 'annual',
}

enum PurchaseType
{
    subscription = 'subscription',
    one_time_charge = 'one_time_charge',
}

function randomEnum(en)
{
    return Object.keys(en)[~~(Math.random() * Object.keys(en).length)];
}

function randomDate(end?)
{
    let prev = end ? end : new Date();
    let delta = end ? Math.random() * 365 * 1000 * 60 * 60 * 24
        : Math.random() * 1000000000000;

    return (new Date(+prev - Math.floor(delta))).getTime();
}

const descriptions =
    [
        'MintData Cloud - Starter Plan',
        'MintData Addon - Custom Domain',
        'MintData Addon - WebCrawler Components',
        'Professional Services',
        'MintData Addon - Unpopular Thing',
        'MintData Cloud - Starter Plan',
        'MintData Cloud - Starter Plan',
    ];

function randomRows()
{
    return Array.apply(null, Array(~~(Math.random() * 7) + 3)).map((a, index) =>
    {
        let unitPrice = parseFloat((Math.random() * 10).toFixed(2));
        let quantity = ~~(Math.random() * 5);
        let toDate = randomDate();
        let fromDate = randomDate(toDate);

        return new InvoiceRowResponse({
            purchaseType: randomEnum(PurchaseType),
            description: descriptions[~~(Math.random() * descriptions.length)],
            subscriptionId: index,
            fromDate: fromDate,
            toDate: toDate,
            quantity: quantity,
            unitPrice: unitPrice,
            unitPeriod: randomEnum(UnitPeriod),
            rowAmount: unitPrice * quantity,
        });
    });
}
